import { Injectable } from '@angular/core';
import { DInfoSugeridaNubeNoExperto } from '@dian-api/sugerida-nube';

export interface KeyValue {
    key: string;
    item: {
        descVar: string[];
        value: any[];
        numNitInformante: any[];
        nomRazonSocialInformante: any[];
    }
}

@Injectable()
export class SugeridaSingletonService {

    private data: Map<string, KeyValue> = new Map();

    arrToMap(data: DInfoSugeridaNubeNoExperto[]) {
        data.forEach((item: DInfoSugeridaNubeNoExperto) => {
            if (item.hasOwnProperty('codVariable') && item.hasOwnProperty('desVariable') && item.hasOwnProperty('variable')) {
                const key = item['codVariable'];
                if (this.data.has(key)) {
                    const obj = this.data.get(key);
                    obj.item.descVar.push(item['desVariable']);
                    obj.item.value.push(item['variable']);
                    obj.item.numNitInformante.push(item['numNitInformante']);
                    obj.item.nomRazonSocialInformante.push(item['nomRazonSocialInformante']);
                    this.data.set(key, obj);
                } else {
                    const value = {
                        descVar: [item['desVariable']],
                        value: [item['variable']],
                        numNitInformante: [item['numNitInformante']],
                        nomRazonSocialInformante: [item['nomRazonSocialInformante']]
                    };
                    this.data.set(key, {
                        key: key,
                        item: value
                    });
                }                
            }
        });        
    }

    getDataArrFromMap(fields: string[]): KeyValue[] {
        const arr: KeyValue[] = [];

        fields.forEach(val => {
            if (this.data.has(val)) {
                const item = this.data.get(val);
                arr.push(item);
            }     
        });

        return arr;
    }

}



// WEBPACK FOOTER //
// D:/GITHUB/F210/V18/rec_ng_renta210v18/src/app/services/sugerida.service.ts